<!-- NO FORM -->
<div class="mg-no-form-container"
     *ngIf="elementSelected && elementSelected.pk == 'version'">
  <span class="material-symbols-outlined mg-no-form-icon">
    info
  </span>
  <!--  <mat-icon class="">list_alt_add</mat-icon> -->
  <span class="mg-no-form-text">Fields can not be edited in a Version. Select a Form to edit fields. After that you can
    Publish a new version.</span>
</div>

<div class="content-general">
  <div class="general">
    <!-- BUTTONS -->
    <div class="buttons"
         *ngIf="elementSelected.pk == 'form'">
      <button (click)="create()"
              class="btn-style flex justify-content-center align-items-center me-1">
        <span class="material-symbols-outlined icon-style">
          add
        </span>
        <span class="text-sm">Field</span>
      </button>
      <!-- <button *ngIf="!arraysEqualIgnoreOrder(fields, elementSelected.fields)" (click)="save()" class="btn-style flex justify-content-center align-items-center me-1">
        <span class="material-symbols-outlined icon-style">
          save
        </span>
        <span class="text-sm">Save</span>
      </button>
      <button  *ngIf="!arraysEqualIgnoreOrder(fields, elementSelected.fields)" (click)="cancel()" class="btn-style flex justify-content-center align-items-center me-1">
        <span class="material-symbols-outlined icon-style">
          cancel
        </span>
        <span class="text-sm">Cancel</span>
      </button>           
      <button style="margin-left: auto;" class="btn-style btn-danger flex justify-content-center align-items-center me-1">
        <span class="material-symbols-outlined icon-style">
          delete
        </span>
        <span class="text-sm">Delete</span>
      </button> -->
    </div>

    <!-- TABLE  -->
    <div class="container-table"
         [ngClass]="{'container-table-resize': showSearchToolbar}">
      <ngx-datatable class="bootstrap"
                     [rows]="fields"
                     [columnMode]="columnMode.force"
                     [headerHeight]="50"
                     [footerHeight]="0"
                     [rowHeight]="40"
                     [scrollbarV]="true"
                     [selected]="selectedData"
                     [selectionType]="selectionType.checkbox"
                     [selectAllRowsOnPage]="false"
                     (activate)="onActivate($event)"
                     (select)="onSelect($event)"
                     (sort)="sortTable($event)">
        <!-- CHECKBOX -->
        <!-- <ngx-datatable-column [width]="30"
                              [sortable]="false"
                              [canAutoResize]="false"
                              [draggable]="false"
                              [resizeable]="false"
                              [headerCheckboxable]="true"
                              [checkboxable]="true">
        </ngx-datatable-column> -->
        <!-- <ngx-datatable-column [flexGrow]="1"
                              [width]="50"
                              [sortable]="false"
                              [canAutoResize]="false"
                              [draggable]="false"
                              [resizeable]="false">
          <ng-template ngx-datatable-header-template
                       let-value="value"
                       let-allRowsSelected="allRowsSelected"
                       let-selectFn="selectFn">
            <div class="mng-checkbox">
              <input type="checkbox"
                     [checked]="allRowsSelected"
                     (change)="selectFn(!allRowsSelected)" />
              <span class="checkbox"></span>
            </div>
          </ng-template>
          <ng-template ngx-datatable-cell-template
                       let-value="value"
                       let-isSelected="isSelected"
                       let-onCheckboxChangeFn="onCheckboxChangeFn">
            <div class="mng-checkbox">
              <input type="checkbox"
                     [checked]="isSelected"
                     (change)="onCheckboxChangeFn($event)" />
              <span class="checkbox"></span>
            </div>
          </ng-template>
        </ngx-datatable-column> -->

        <ngx-datatable-column [width]="30"
                              [sortable]="false"
                              [canAutoResize]="false"
                              [draggable]="false"
                              [resizeable]="false">
          <ng-template ngx-datatable-header-template
                       let-value="value"
                       let-allRowsSelected="allRowsSelected"
                       let-selectFn="selectFn">
            <div class="mng-checkbox">
              <input type="checkbox"
                     [checked]="allRowsSelected"
                     (change)="selectFn(!allRowsSelected)" />
              <span class="checkbox"></span>
            </div>
          </ng-template>
          <ng-template ngx-datatable-cell-template
                       let-value="value"
                       let-isSelected="isSelected"
                       let-onCheckboxChangeFn="onCheckboxChangeFn">
            <div class="mng-checkbox">
              <input type="checkbox"
                     [checked]="isSelected"
                     (change)="onCheckboxChangeFn($event)" />
              <span class="checkbox"></span>
            </div>
          </ng-template>
        </ngx-datatable-column>

        <!-- FIELDS      -->
        <ngx-datatable-column [headerClass]="'header-style'"
                              [minWidth]="200"
                              [flexGrow]="1"
                              *ngFor="let prop of selectedProperties"
                              name="{{ prop.label | uppercase }}"
                              prop="{{ prop.name }}">
          <ng-template ngx-datatable-cell-template
                       let-value="value"
                       let-isSelected="isSelected"
                       let-onCheckboxChangeFn="onCheckboxChangeFn">
            <span>{{ value }}</span>
          </ng-template>
        </ngx-datatable-column>

        <!-- ACTIONS -->
        <ngx-datatable-column [headerClass]="'header-style'"
                              [flexGrow]="1"
                              [width]="100"
                              [sortable]="false"
                              [canAutoResize]="false"
                              [draggable]="false"
                              [resizeable]="false">
          <ng-template ngx-datatable-header-template>
            <div>
              <label>ACTIONS</label>
            </div>
          </ng-template>

          <ng-template ngx-datatable-cell-template
                       let-rowIndex="rowIndex">
            <!-- Disabled -->
            <span *ngIf="elementSelected && elementSelected.pk != 'version'"
                  class="material-symbols-outlined icon-update">
              edit
            </span>
            &nbsp;&nbsp;&nbsp;
            <span *ngIf="elementSelected && elementSelected.pk != 'version'"
                  class="material-symbols-outlined icon-delete">
              delete
            </span>
            <!-- Enabled -->
            <span *ngIf="elementSelected && elementSelected.pk == 'version'"
                  class="disabled material-symbols-outlined icon-update">
              edit
            </span>
            &nbsp;&nbsp;&nbsp;
            <span *ngIf="elementSelected && elementSelected.pk == 'version'"
                  class="disabled material-symbols-outlined icon-delete">
              delete
            </span>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>

    <!-- <div class="selected-column">
      <h4>
        Selections <small>({{ selected?.length }})</small>
      </h4>
      <ul>
        <li *ngFor="let sel of selected">
          {{ sel.name }}
        </li>
        <li *ngIf="!selected?.length">No Selections</li>
      </ul>
    </div> -->
  </div>
</div>